import React, { Component } from 'react';

import { StringUtils } from '../utils';
import { Routes as routes } from '../navigation';
import '../css/UserProfile.css';
import { Switch, Button, Header, Line } from '../components';

class UserNotificationPreferences extends Component {

  constructor(props) {
    super(props);
    this.state = {
      updated_preferences: null,
    }
  }

  componentDidMount() {
    let existing_preferences = this.props.notificationPreferences;
    let token   = this.props.token;
    let user_id = this.props.user && this.props.user._id ? this.props.user._id : '';
    this.setState({ ...this.state, updated_preferences: existing_preferences });
    if (token && user_id) {
      this.props.userActions.getUserNotificationPreferences(token, user_id, this.updateCallback)
    }
  }

  renderLine = () => {
    return <div style={{ width: '100%', backgroundColor: '#e7e7e7', height: 1, marginTop: 12, marginBottom: 10 }}></div>
  }

  renderAllNotificationsSwitch = () => {
    let preferences = this.state.updated_preferences;
    let all_notifs  = preferences.notifications_on === true ? true : false;

    return <div className='flex-container-row' style={{ flex: 1, justifyContent: 'flex-end', alignItems: 'center', paddingRight: 10 }}>
      <span style={{ marginRight: 10, fontSize: 14, color: '#575757' }}>All Notifications</span>
      <Switch on={all_notifs} small={true} onClick={() => {
        let preferences = this.state.updated_preferences;
        preferences['notifications_on'] = !preferences.notifications_on;
        this.setState({ ...this.state, updated_preferences: preferences });
        this.props.userActions.updateUserNotificationPreferences(this.props.token, preferences);
      }} />
    </div>
  }

  renderUserNotificationPreferences = () => {
    let preferences = this.state.updated_preferences;
    let all_notifs  = preferences.notifications_on === true ? true : false;

    if (all_notifs === false) {
      return <div className="standard-container">
        <div className='flex-container-row' style={{ alignItems: 'center', marginBottom: -5, width: '100%' }}>
          <span style={{ flex: 1, fontSize: 14, letterSpacing: 0.4, fontWeight: 'bold', color: '#575757' }}><span className='fas fa-bell' style={{ marginRight: 10, color: '#1dc2ff' }} />Notification Preferences</span>
          { this.renderAllNotificationsSwitch() }
        </div>
      </div>
    }

    return <div className="standard-container">
        <div className='flex-container-row' style={{ alignItems: 'center', padding: 10, width: '100%' }}>
          <span style={{ flex: 1, fontSize: 14, letterSpacing: 0.4, fontWeight: 'bold', color: '#575757' }}><span className='fas fa-bell' style={{ marginRight: 10, color: '#1dc2ff' }} />Notification Preferences</span>
          { this.renderAllNotificationsSwitch() }
        </div>

        <Line />

        <div style={{ padding: 15, paddingTop: 5 }}>
        <div className='flex-container-row' style={{ alignItems: 'center', width: '100%' }}>
          <div style={{ flex: 1 }}></div>
          <div className='flex-container-row' style={{ flex: 1, justifyContent: 'flex-end', alignItems: 'center', paddingRight: 3, marginBottom: 3 }}>
            <div className='flex-container-row' style={{ width: 60, justifyContent: 'center', fontSize: 10, color: '#575757' }}>EMAIL</div>
            <div className='flex-container-row' style={{ width: 60, justifyContent: 'center', fontSize: 10, color: '#575757' }}>TEXTS</div>
            <div className='flex-container-row' style={{ width: 60, justifyContent: 'center', fontSize: 10, color: '#575757' }}>PUSH</div>
          </div>
        </div>

        { this.renderCategoryRow('New Consultation', 'Client started a consultation with you', 'new_consultation') }
        { this.renderLine() }
        { this.renderCategoryRow('New Message', 'Received a new message in a consultation', 'new_message') }
        { this.renderLine() }
        { this.renderCategoryRow('Resolved Consultation', 'Consultation you were involved in was resolved', 'resolve_consultation') }
        { this.renderLine() }
        { this.renderCategoryRow('Appointments', 'New or updated appointment with you', 'appointments') }
        { this.renderLine() }
        { this.renderCategoryRow('Added as Participant', 'You have been added to a consultation', 'added_as_participant') }
        </div>
    </div>
  }

  renderCategoryRow = (title, description, key) => {

    let preferences = this.state.updated_preferences;
    let email_on    = preferences[key] && preferences[key].email && preferences[key].email === true ? true : false;
    let texts_on    = preferences[key] && preferences[key].text  && preferences[key].text === true ? true : false;
    let push_on     = preferences[key] && preferences[key].push  && preferences[key].push === true ? true : false;

    return <div className='flex-container-row' style={{ alignItems: 'center', width: '100%' }}>

      <div className='flex-container-column' style={{ flex: 1 }}>
        <span style={{ fontSize: 13, color: '#575757' }}>{ title }</span>
        <span style={{ fontSize: 12, color: 'grey', marginTop: -3 }}>{ description }</span>
      </div>

      <div className='flex-container-row'
           style={{ flex: 1, justifyContent: 'flex-end', alignItems: 'center', paddingRight: 2 }}
           onClick={ () => { this.setState({ ...this.state, expanded_category: key }) }}>
        <div className='flex-container-row'>
          <div className='flex-container-row' style={{ width: 60, justifyContent: 'center', fontSize: 14 }}><Switch on={email_on} small={true} onClick={() => { this.updateSwitchAction('email', key, !email_on) }} /></div>
          <div className='flex-container-row' style={{ width: 60, justifyContent: 'center', fontSize: 14 }}><Switch on={texts_on} small={true} onClick={() => { this.updateSwitchAction('text', key, !texts_on) }} /></div>
          <div className='flex-container-row' style={{ width: 60, justifyContent: 'center', fontSize: 14 }}><Switch on={push_on}  small={true} onClick={() => { this.updateSwitchAction('push', key, !push_on) }} /></div>
        </div>
      </div>

    </div>
  }

  render() {
    if (this.props.hide) {
      return null;
    }
    return this.state.updated_preferences ? this.renderUserNotificationPreferences() : null;
  }

  updateSwitchAction = (type, category, value) => {
    let preferences = this.state.updated_preferences;
    preferences[category][type] = value;
    this.setState({ ...this.state, updated_preferences: preferences });
    this.props.userActions.updateUserNotificationPreferences(this.props.token, preferences);
  }

  updateCallback = (preferences) => {
    this.setState({ ...this.state, updated_preferences: preferences });
  }

}

export default UserNotificationPreferences
